<div class=" sticky-top rotated">
    <div class=" banner ">
    {{userInfo}}
    </div>
</div>